import { defineComponent as _defineComponent } from 'vue'
import AbLink from '../AbLink/AbLink.vue';
import AbIcon from '../AbIcon/AbIcon.vue';
import useProps from '../../../composables/useProps';
import AbButtonEffectGlow from './AbButtonEffectGlow.vue';
import { computed } from 'vue-demi';

interface Props {
  variant?: string | null;
  size?: string | null;
  block?: boolean | null;
  inverted?: boolean | null;
  multilayered?: boolean | null;
  fitHeight?: boolean | null;
  minWidth?: string | null;
  icon?: string | null;
  disabled?: boolean | null;
  type?: string | null;
  target?: string | null;
  to?: string | null;
  effect?: 'glow' | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbButton',
  props: {
    variant: null,
    size: null,
    block: { type: [Boolean, null] },
    inverted: { type: [Boolean, null] },
    multilayered: { type: [Boolean, null] },
    fitHeight: { type: [Boolean, null] },
    minWidth: null,
    icon: null,
    disabled: { type: [Boolean, null] },
    type: null,
    target: null,
    to: null,
    effect: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({ (e: 'click'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  variant?: string | null;
  size?: string | null;
  block?: boolean | null;
  inverted?: boolean | null;
  multilayered?: boolean | null;
  fitHeight?: boolean | null;
  minWidth?: string | null;
  icon?: string | null;
  disabled?: boolean | null;
  type?: string | null;
  target?: string | null;
  to?: string | null;
  effect?: 'glow' | null;
};

const BUTTON_VARIANTS = [
  'primary',
  'secondary',
  'tertiary',
  'outlined',
  'cyan',
  'pink',
  'white',
];





const clickEvent = () => {
  emit('click');
};
const state = computed(() => ({
  variant: props.variant ?? 'primary',
  size: props.size ?? 'md',
  block: props.block ?? false,
  inverted: props.inverted ?? false,
  multilayered: props.multilayered ?? false,
  fitHeight: props.fitHeight ?? false,
  minWidth: props.minWidth ?? 'auto',
  icon: props.icon ?? undefined,
  disabled: props.disabled ?? false,
  type: props.type ?? 'button',
  target: props.target ?? undefined,
  to: props.to ?? undefined,
  effect: props.effect ?? undefined,
}));

const currentProps = useProps('AbButton', { ...state.value });
const currentVariant = computed(() => {
  let variant = BUTTON_VARIANTS.includes(currentProps.value.variant)
    ? currentProps.value.variant
    : 'primary';
  return `ab-button-${variant}`;
});

return { __sfc: true,BUTTON_VARIANTS, props, emit, clickEvent, state, currentProps, currentVariant, AbLink, AbIcon, AbButtonEffectGlow }
}

})